import { Title } from '@shared/models/customer';

export const CUSTOMER_TITLE_LIST: Title[] = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr (Female)', 'Dr (Male)'];
